import React from 'react';
import { Box, keyframes, useMediaQuery, useTheme } from '@mui/material';

interface HaloEffectProps {
  children: React.ReactNode;
  color?: string;
  duration?: number;
  enabled?: boolean;
  compact?: boolean;
}

const pulseAnimation = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.75);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0;
  }
`;

export const HaloEffect: React.FC<HaloEffectProps> = ({
  children,
  color = '#D91E6C',
  duration = 2,
  enabled = true,
  compact,
}) => {
  const theme = useTheme();
  const isVeryWideScreen = useMediaQuery(theme.breakpoints.up('xl'));

  // Always compact unless on very wide screens and compact is not forced (same logic as ToolbarButton)
  const shouldShowCompact = compact !== false || !isVeryWideScreen;
  const leftPosition = shouldShowCompact ? '50%' : '22px';
  // Smaller size for non-compact mode since we're only highlighting the icon
  const size = shouldShowCompact ? 48 : 42;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {enabled && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: leftPosition,
            width: size,
            height: size,
            borderRadius: '50%',
            border: `2px solid ${color}`,
            animation: `${pulseAnimation} ${duration}s linear infinite`,
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
      )}
      <Box sx={{ position: 'relative', zIndex: 1 }}>{children}</Box>
    </Box>
  );
};
